import { AppliedFacet } from '../types';
import { Option } from '../../../../types';

const checkOptionAndAppliedFacets = (
  option: Option,
  appliedFacets: AppliedFacet
) => {
  if (typeof appliedFacets === 'undefined') {
    return false;
  }
  if (typeof option === 'undefined') {
    return false;
  }
  return true;
};

const getAppliedOptions = (appliedFacets: AppliedFacet, facetName: string) =>
  appliedFacets[facetName] ?? [];

const isOptionApplied = (
  option: Option,
  appliedFacets: AppliedFacet,
  facetName: string
) => {
  const isOptionAndAppliedFacetsAvailable = checkOptionAndAppliedFacets(
    option,
    appliedFacets
  );
  if (isOptionAndAppliedFacetsAvailable) {
    const appliedOptions = getAppliedOptions(appliedFacets, facetName);
    const isAnyOptionApplied = appliedOptions.length > 0;

    if (!isAnyOptionApplied) {
      return false;
    }

    const matchCurrentOption = ({ id }: Option) => id === option.id;
    return appliedOptions.some(matchCurrentOption);
  }

  return false;
};

export default isOptionApplied;
